import * as z from "zod/v4";
import { PrinterOptionsSchema } from "../printnode/printer";

export const printPackingSlipInputSchema = z.intersection(
  z.union([
    z.object({ fulfillmentGroupIds: z.array(z.string()) }),
    z.object({ batchId: z.string() }),
  ]),
  z.object({
    templateId: z.string().optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    printFast: z.boolean().nullish(),
    idempotencyKey: z.string().optional(),
    initiationTime: z.number().nullish(),
  }),
);

export type PrintPackingSlipInput = z.infer<typeof printPackingSlipInputSchema>;
